import axiosInstance from '../../../config/axiosInstance';
const  AssetDocumentService = {
    async GetAllAssetDocument(redirectCallback,ID) {
        try {            
           const response = await axiosInstance.get(`/Asset/GetAllAssetsDocuments?ID=${ID}`);
           return response.data;
        } catch (error) {
            if(error.response.data.message=="Invalid token")
            {
                redirectCallback();
                return;
            }
            console.error('Error fetching data:', error);
            throw error;
        }
    },
    async DeleteAssetDocument(redirectCallback,ID) {
        try {            
            const response = await axiosInstance.get(`/Asset/DeleteAssetDocument?ID=${ID}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }
};

export default AssetDocumentService;